// services/authNavigation.ts

/**
 * Client-side navigation for code outside React (the axios interceptor, the
 * native deep-link handler). The app registers the router once; until then,
 * or in tests, a full-page navigation is the fallback.
 */
type Navigator = (path: string, options?: { replace?: boolean }) => void;

let navigator: Navigator | null = null;

export const registerAuthNavigator = (next: Navigator | null): void => {
  navigator = next;
};

export const navigateForAuth = (
  path: string,
  options?: { replace?: boolean }
): void => {
  if (navigator) {
    navigator(path, options);
    return;
  }

  if (options?.replace) {
    window.location.replace(path);
  } else {
    window.location.assign(path);
  }
};

/** Where an account lands to set up two-factor authentication. */
export const SECURITY_SETTINGS_PATH = '/account?sub=security';
export const TWO_FACTOR_SETUP_PATH = `${SECURITY_SETTINGS_PATH}&setup2fa=1`;

/**
 * Where the auth page parks its `?redirect=` path (sessionStorage) so it
 * survives an OAuth round trip and the 2FA page.
 */
export const AUTH_REDIRECT_STORAGE_KEY = 'ora-auth-redirect';
